import React from "react";
import { Box, Typography } from "@mui/material";

import { WarnIcon } from "../../Icons";
import { SubmitButton } from "../Button/SubmitButton";

export const AttentionModal = ({
  headerTitle,
  title,
  subTitle,
  description,
  okButtonTitle,
  onButtonClick,
}: any) => {
  return (
    <Box
      sx={{
        padding: "33px",
        borderRadius: "16px",
        width: "496px",
      }}
    >
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            width: "80px",
            height: "80px",
            backgroundColor: "rgba(251, 173, 21, 0.1)",
            marginBottom: "24px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "50%",
              width: "40px",
              height: "40px",
              backgroundColor: "#FBAD15",
              color: "white",
            }}
          >
            <WarnIcon />
          </Box>
        </Box>

        <Typography
          sx={{
            fontSize: "32px",
            fontWeight: "600",
            color: "#080808",
            marginBottom: "16px",
          }}
        >
          {headerTitle}
        </Typography>
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: "400",
            color: "#363636",
            marginBottom: "16px",
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: "500",
            color: "#1F1F1F",
            marginBottom: "8px",
          }}
        >
          {subTitle}
        </Typography>
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: "400",
            color: "#1F1F1F",
            marginBottom: "40px",
          }}
        >
          {description}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
        }}
      >
        <SubmitButton
          title={okButtonTitle}
          onClick={onButtonClick}
          sx={{
            flex: 1,
            backgroundColor: "white",
            color: "#BF295C",
            border: "2px solid #BF295C",
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
        />
      </Box>
    </Box>
  );
};
